import React, {Component} from 'react';
import StaffList from './staff-list'
import {Link} from 'react-router-dom'
import {Col, Row} from 'react-bootstrap'
import ArrowButton from '../common/button-arrow';
import {connect} from 'react-redux';
import Can from '../common/guards/can';

class MyStaff extends Component {
  renderStaffList = () => {

    const {fetched, relationships} = this.props;

    let renderedStafflist = "";
    let registeredStaffMembers = [];

    if (fetched && relationships) {
      relationships.staff_members.forEach((curr) => {

        if (curr.status === "registered") {
          registeredStaffMembers.push(curr)
        }
      });

      renderedStafflist = (
        <Can action="handle" subjectClass="staff">
          <div className="relationships">
            <Row>
              <Col lg={12}>
                <StaffList staff={registeredStaffMembers} fetching={false} fetched={true}/>
              </Col>
            </Row>
                    <Row>
          <Col lg={12} className="manage-staff-container">

            <Link to={'/my-staff'}>
              <ArrowButton submit={false}
                          arrow={false}
                          className="pull-right manage-staff">Manage staff</ArrowButton>
            </Link>
            </Col>
            </Row>
          </div>
        </Can>
      );
    }

    return renderedStafflist;
  };

  render() {
    return (
      <div className="store-details">
        {this.renderStaffList()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    relationships:  state.store.relationships,
    fetched:        state.store.fetched,
    fetching:       state.store.fetching,
  };
};

export default connect(mapStateToProps)(MyStaff);



// WEBPACK FOOTER //
// ./src/components/store-details/my-staff.jsx